import { Type } from 'class-transformer';
import { IsDefined, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { FileId } from '../../../../types';
import { FileDto } from '../../../file/file-dto';
import { PropertyDocumentStatus, PropertyDocumentType } from './property-enums';

export class PropertyDocumentDto {
  @IsNotEmpty()
  @IsEnum(PropertyDocumentType)
  type: PropertyDocumentType = PropertyDocumentType.OTHER;

  @IsDefined()
  @ValidateNested()
  @Type(() => FileDto)
  file!: FileDto | FileId;

  @IsOptional()
  @IsString()
  label?: string;

  @IsOptional()
  @IsString()
  url?: string;

  @IsOptional()
  @IsEnum(PropertyDocumentStatus)
  status: PropertyDocumentStatus = PropertyDocumentStatus.PENDING_REVIEW;

  @IsOptional()
  @IsString()
  rejectionReason?: string;
}

export class PatchPropertyDocumentStatusDto {
  @IsNotEmpty()
  @IsEnum(PropertyDocumentStatus)
  status!: PropertyDocumentStatus;

  @IsOptional()
  @IsString()
  rejectionReason?: string;
}
